// src/data/gamesData.js

export const GAMES = [
  {
    id: "switch-lane",
    title: "Switch Lane",
    genre: "Endless Runner",
    role: "Game Developer · Game Designer",
    duration: "Nov 2026",
    points: [
      "Developed a fast-paced endless runner where players switch between three lanes to dodge obstacles and survive as long as possible",
      "Built a responsive lane-switching mechanic with smooth transitions and timing-based obstacle avoidance",
      "Created increasing speed and difficulty over time, with score and personal best tracking",
    ],
    tech: "Unity · C#",
    img: "/assets/img/project15.png",
    externalUrl: "https://tthtung274.itch.io/switch-lane",
    howToPlay: [
      "Press ← / → to switch lanes.",
      "On supported touch devices, swipe left or right to change lanes.",
      "Avoid obstacles and survive as long as possible.",
    ],
  },
  {
    id: "stack-up",
    title: "Stack Up",
    genre: "Arcade",
    role: "Game Developer · Game Designer",
    duration: "Oct 2026",
    points: [
      "Developed a game where players stack moving blocks to build the tallest tower possible",
      "Built a timing-based precision mechanic where blocks must align with the tower before dropping",
      "Created increasing difficulty as the tower grows, with score and personal best tracking",
    ],
    tech: "Unity · C#",
    img: "/assets/img/project14.png",
    externalUrl: "https://tthtung274.itch.io/stack-up",
    howToPlay: [
      "Click, press Space, or tap the screen to drop the moving block.",
      "Align the block with the tower and drop it as accurately as possible to stack higher.",
    ],
  },
  {
    id: "clapping-bird",
    title: "Clapping Bird",
    genre: "Arcade",
    role: "Game Developer · Game Designer",
    duration: "Oct 2026",
    points: [
      "Developed a game where players control a bird flapping through obstacles",
      "Built a gravity-reversal mechanic triggered every 5 points, forcing players to adapt constantly",
      "Created moving obstacles that increase difficulty as the game progresses",
    ],
    tech: "Unity · C#",
    img: "/assets/img/project13.png",
    externalUrl: "https://tthtung274.itch.io/clapping-bird",
    howToPlay: [
      "Click, press Space, or tap the screen to flap and fly through the pipes.",
      "Every 5 points, gravity flips — your bird falls upward instead, so adapt fast.",
      "Pipes move as you progress, raising the difficulty every run.",
    ],
  },
  {
    id: "the-hegemons",
    title: "The Hegemons",
    genre: "Action",
    role: "Game Developer · Game Designer",
    duration: "Jun 2026 - Oct 2026",
    points: [
      "Develop a survival action game featuring wave-based enemy combat",
      "Create a team of 4 characters with distinct roles, abilities, and stats to encourage tactical gameplay",
      "Implement auto-movement and auto-attack mechanics for allies and enemies",
    ],
    tech: "Unity · C#",
    img: "/assets/img/project12.png",
    externalUrl: "https://tthtung274.itch.io/the-hegemons",
    howToPlay: [
      "Pick your character color before starting.",
      "Press 1–4 to switch characters — control one while the others fight automatically.",
      "Click the battlefield to move your selected character.",
      "Use Q, W, E to activate abilities.",
      "Survive the enemy waves and lead your team to victory.",
    ],
  },
  {
    id: "foodie-sizzle",
    title: "Foodie Sizzle Clone",
    genre: "Puzzle",
    role: "Game Developer",
    duration: "May 2026",
    points: [
      "Match-3 identical skewers to serve customers and complete each level",
      "Manage your moves carefully to overcome obstacles and finish challenges",
      "Discover exciting mechanics such as locked ingredients and special serving requests",
      "Bright visuals and relaxing gameplay make Foodie Sizzle perfect for stress relief",
    ],
    tech: "Unity · C# · Git",
    img: "/assets/img/project11.png",
    gamePath: "/assets/Foodie-Sizzle-Clone/index.html",
    isVertical: true,
    github: "https://github.com/tthtung274/FoodieSizzle",
    githubLabel: "FoodieSizzle",
    howToPlay: [
      "Drag food skewers around the board.",
      "Match 3 or more identical skewers to clear them and fulfill orders.",
      "Complete each level's objectives before time runs out.",
      "Use boosters strategically to clear obstacles and tough levels.",
    ],
  },
  {
    id: "candy-boom",
    title: "Candy Boom",
    genre: "Puzzle",
    role: "Game Developer",
    duration: "May 2026",
    points: [
      "Match and blast candies in this addictive puzzle adventure",
      "Fun and challenging puzzles with many different level objectives",
      "Bright colorful worlds packed with exciting candy challenges",
    ],
    tech: "Unity · C#",
    img: "/assets/img/project10.png",
    gamePath: "/assets/Candy-Boom/index.html",
    howToPlay: [
      "Click or tap a candy, then swap it with an adjacent candy.",
      "Match 3 or more candies of the same color to clear them and earn points.",
      "Complete the level's objective before running out of moves."
    ],
  },
  {
    id: "3x3-arena",
    title: "3x3 Arena",
    genre: "Action",
    role: "Game Developer",
    duration: "Apr 2026",
    points: [
      "Play a classic 3x3 board game focused on tactical decision-making.",
      "Choose a difficulty level and take turns placing pieces on the board.",
      "Plan your moves carefully to outsmart your opponent and win by aligning three pieces in a row."
    ],
    tech: "Unity · C#",
    img: "/assets/img/project8.png",
    gamePath: "/assets/3x3-Arena/index.html",
    howToPlay: [
      "Choose your preferred difficulty level before starting the game.",
      "Click or tap an empty cell on the board to place your game piece.",
      "Outmaneuver your opponent with strategic moves and win the match."
    ],
  },
];

export const getGameById = (id) => GAMES.find((g) => g.id === id);

/* ============================================================
   Gợi ý game — luôn trả về tối đa `limit` game.
   Ưu tiên TUYỆT ĐỐI: game cùng genre luôn đứng ĐẦU danh sách,
   sau đó mới bù bằng game khác genre.

   Logic:
   - Lấy current game ra.
   - Tách others thành sameGenre / differentGenre.
   - Ghép [...sameGenre, ...differentGenre] rồi cắt `limit`.

   => Sửa lỗi cũ: nhánh `if (others.length <= limit) return others;`
      trả về nguyên thứ tự gốc, khiến game cùng genre bị đẩy xuống cuối
      khi tổng số game <= limit (ví dụ chỉ có 5 game như hiện tại).
   ============================================================ */
export const getRelatedGames = (currentId, limit = 6) => {
  const current = GAMES.find((g) => g.id === currentId);
  if (!current) return GAMES.slice(0, limit);

  const others = GAMES.filter((g) => g.id !== currentId);

  const sameGenre = others.filter((g) => g.genre === current.genre);
  const differentGenre = others.filter((g) => g.genre !== current.genre);

  // Luôn ưu tiên cùng genre lên đầu, rồi mới đến khác genre
  return [...sameGenre, ...differentGenre].slice(0, limit);
};